import React from "react";

import styled from "@emotion/styled";

const AchtungIcon = ({ color = "#e60028", hoverColor = color }) => {
    const SVG = styled.svg`
        fill: ${color};

        &:hover {
            fill: ${hoverColor};
        }
    `;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="26"
            height="24"
            viewBox="0 0 26 24"
        >
            <g
                id="Icons_Web_final_achtung"
                transform="translate(-0.644 -2.112)"
            >
                <path
                    id="Pfad_2350"
                    data-name="Pfad 2350"
                    d="M25.056,26.11H2.221a1.543,1.543,0,0,1-1.386-.8,1.74,1.74,0,0,1,.046-1.671h0L12.294,2.926a1.518,1.518,0,0,1,2.691,0L26.4,23.64a1.676,1.676,0,0,1,.047,1.671,1.49,1.49,0,0,1-1.387.8ZM2.875,24.87h0v0Zm.662-1.2h20.2L13.638,5.332Z"
                    transform="translate(0 0)"
                    fill="#e60028"
                />
                <path
                    id="Pfad_2351"
                    data-name="Pfad 2351"
                    d="M11,19.99V17.548h2.307V19.99Zm2.307-3.663H11V9h2.307Z"
                    transform="translate(1.588 1.523)"
                    fill="#e60028"
                />
            </g>
        </svg>
    );
};

export default AchtungIcon;
